module.exports = "https://static.im-cdn.com/mjc/storefront/Coral/static/media/shareWhatsapp.b9553ceb.svg";